/*!
=========================================================
* お知らせ管理 新規登録
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";

import InputText from '../FormParts/InputText';
import InputSelect from '../FormParts/InputSelect';
import InputDatetime from '../FormParts/InputDatetime'
import InputRadio from '../FormParts/InputRadio';
import InputCheckBox from '../FormParts/InputCheckBox';
import ImageControl from '../FormParts/ImageControl'
import Request from '../../common/Request';
import SystemInfo from '../ViewParts/SystemInfo';
import Images from '../ViewParts/Images';
import {
  cst_information_data_type,
  cst_information_display_header,
  cst_information_display_advertisement,
  cst_information_status,
  cst_information_not_login,
} from '../../variables/codes_map';
import InformationCustomerSelectPopup from '../ViewParts/InformationCustomerSelectPopup';

import CustomTd from '../ViewParts/CustomTd';
import WithRole from '../FormParts/ButtonWithRole';
import { GetMessage, getErrorCodes } from '../../variables/message';
const moment = require("moment");

const domain = "";

/*
*　クラス名：
*     Regist   ：新規登録・更新系クラス
*/
class Regist extends React.Component {
  /*
  *　関数・変数名：
  *     constructor     　：コンストラクタ関数
  *                         ロード時に1度だけ呼び出される
  *  パラメータ 説明：
  *     props            ：GETやPOSTなどのパラメータ入力値
  */  
  constructor(props) {
    /*
    *　関数・変数名：
    *     super     　      ：親のコンストラクターを呼び、thisを使えるようにする
    *  パラメータ 説明：
    *     props            ：GETやPOSTなどのパラメータ入力値
    */    
    super(props);

    /*
    *　関数・変数名：
    *     this.state    ：stateの初期設定
    *  KEY 説明：（※）は必須
    * 
    *     ▼共通設定
    *     valid             ：バリデーションの結果設定
    *                         true　→　正常     false   →　エラー
    *     regist_modal      ：登録・更新時の確認用モーダル表示
    *     error_modal       ：エラー用モーダル表示
    *     presave_modal     ：一時保存用モーダル表示
    * 
    *     ▼画面毎設定　
    *     information_id       ：更新画面用のパラメータ
    *     
    *     ▼共通設定
    *     data              ：更新画面用の元データ格納変数
    *     view              ：新規・更新の判定用変数
    *                         true : 更新   false ： 新規登録      
    */
    this.state = {
      valid: true,
      regist_modal: false,
      error_modal: false,
      presave_modal: false,
      information_id: "",
      data: {
        values:{
          image_url : [],
          thumbnail_url : [],
          data_type : cst_information_data_type[0].default,
          display_header : cst_information_display_header[0].default,
          display_advertisement : cst_information_display_advertisement[0].default,
          status : cst_information_status[0].default
        },
        errors:{
          subject : [GetMessage(2024)],
          body : [GetMessage(2024)],
          start_date : [GetMessage(2024)],
          end_date : [GetMessage(2024)],
        },
        requiredData:{
          subject : [GetMessage(2024)],
          body : [GetMessage(2024)],
          start_date : [GetMessage(2024)],
          end_date : [GetMessage(2024)],
        },
      },
      post_data: {},
      error: {},
      view: false,
      requiredCheck:{},
      targetCustomers: []
    };

  /*
  *　関数・変数名：
  *     this.[関数名]    ：this.stateやthis.propsを関数内で利用する場合に設定
  *  構文：
  * 　　this.[関数名] = this.[関数名].bind(this)
  */
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.togglePresaveModal = this.togglePresaveModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
    this.uploadImageCallback = this.uploadImageCallback.bind(this);
    this.alertDateCheck = this.alertDateCheck.bind(this)

    this.information_customer_select_popup = React.createRef();
  }

  /*
  *　関数・変数名：
  *     UNSAFE_componentWillMount  ：初期ロード時の処理、render前に呼び出される
  *                                 初期化はconstructor内に記述
  *                                 再設定する際に利用
  * 　
  *     詳細は下記URLチェック
  *     https://ja.reactjs.org/docs/react-component.html#unsafe_componentwillmount
  */
  // life cycle method : before rendering 
  // static getDerivedStateFromProps(props, state){
  //   return
  // }
  
  // life cycle method: after rendering
  componentDidMount(){
    /*　ここは開発者が記述　*/
    if (this.props.match.params.information_id != undefined) {
      this.setState({ information_id: this.props.match.params.information_id });
      var url = domain + '/api/information/' + this.props.match.params.information_id;
      let params = {};
      Request.get(url, params, res => {
        this.setState({
          data: {
            ...this.state.data,
            values:{
              ...res.Data,
              image_url: res.data.image_url?res.data.image_url.split(','):[]
            },
            errors : {
              subject : res.Data.subject == null ? [GetMessage(2024)] : undefined,
              body : res.Data.body == null ? [GetMessage(2024)] : undefined,
              start_date : res.Data.start_date == null ? [GetMessage(2024)] : undefined,
              end_date : res.Data.end_date == null ? [GetMessage(2024)] : undefined,
            }
          }, 
          view: true 
        }, ()=>{
          this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
        });
        var url = domain + '/api/landmark/lastupdate/' + res.Data.update_user_id;
        var params = {};
        Request.get(url, params, res => {
          this.setState({
            data:{
              ...this.state.data,
              values:{
                ...this.state.data.values,
                lastupdate_user:res.Data,
              }
            }
          }, ()=>{
            this.setRequiredData()
            this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
          });
        });
      });
      Request.get(`/api/information/target`, {information_id : this.props.match.params.information_id}, res => {
        this.setState({
          targetCustomers:res.Data
        });
      });
    } else {
      this.setRequiredData()
    }
  }

  setRequiredData = async ()=>{
    // const url = domain + '/api/information';
    // const requiredCheckedData = await Request.getRequiredData(url, this.state.data)
    // this.setState({
    //   data:requiredCheckedData
    // })
  }
  /*
  *　関数・変数名：
  *     validate    ：バリデーションのエラー判定用関数
  *                   エラーがあるか無いかの判定のみ
  *                   バリデーションのチェックは、フォームのコンポーネント側に実装 
  */  
  validate() {
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  /*
  *　関数・変数名：
  *     validate_[定義名]    ：Inputフォームのバリデーション結果を受け取るためのCallback関数
  *                            専用コンポーネント（InputTelやInputNumberなど）の場合に記述方法
  *                           render内のvalidateCallback関数に設定した名前を追記する
  *  パラメータ 説明：
  *         valid        ：バリデーション結果
  *          tel         ：入力値 
  * 
  */  
  validateCallback(newData, callback=()=>{}){
    const data = this.state.data;

    // すべてを選択した場合、ターゲットをクリアする
    if(this.state.data.values.data_type !== newData.values.data_type){
      this.setState({
        targetCustomers : []
      })
    }

    const mergedData = {
      ...this.state.data,
      ...this.alertDateCheck(newData)
    }
    //
    if(this.state.data.values.data_type !== newData.values.data_type){
      if(newData.values.data_type == "5"){
        mergedData.values.not_login = 1;
      }else{
        mergedData.values.not_login = 0;
      }
    }

    this.setState({
      data:{
        ...mergedData
      }
    }, ()=>callback())
  }

  alertDateCheck(newData){
    const {
      start_date,
      end_date
    } = newData.values
    const {
      start_date:prev_start_date,
    } = this.state.data.values
    if(start_date && end_date && (moment(start_date) > moment(end_date))){
      return {
        ...newData,
        errors:{
          ...newData.errors,
          ...{[(prev_start_date === start_date ? 'end_date' : 'start_date')]:[GetMessage(2431)]},
        }
      }
    }else{
      return newData
    }
  }

  /*
  *　関数・変数名：
  *     toggle[任意モーダル名]  ：　Class内でモーダルを表示の簡易版
  *                                確認及び結果表示のみに利用
  *                                複雑な処理をする場合は、専用モーダルかDialogBaseを利用
  *     
  */   
  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }
  togglePresaveModal() {
    this.setState({
      presave_modal: !this.state.presave_modal
    });
  }

  /*
  *　関数・変数名：
  *     regist ： 登録及び更新APIのリクエスト用関数
  *     
  */   
  regist() {
    const {
      data,
      view,
      targetCustomers
    } = this.state
    const url = domain + '/api/information';
    if(view === false) {
      Request.post(url, {...data.values, targetCustomers}, res => {
        if (res.Code>=800) {
          this.setState({
            data:{
              ...data,
              errors:res.Data
            }
          })
        } else {
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push('/information');
        }
      });
    } else {
      Request.put(url + "/" + data.values.information_id, {...data.values, targetCustomers}, res => {
        if (res.Code>=800) {
          this.setState({
            data:{
              ...data,
              errors:res.Data
            }
          })
        } else {
          // update success
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push(`/information/detail/${this.props.match.params.information_id}`) 
        }
      });
    }
  }

  /*
  *　関数・変数名：
  *     button_name ：this.state.viewを利用し、ボタン名の判定用関数
  *     
  */   
  button_name() {
    if (this.state.view === false) {
      return "登録";
    } else {
      return "更新";
    }
  }

  /*
  *　関数・変数名：
  *     button_name ：this.state.viewを利用し、タイトルの判定用関数
  *     
  */   
  set_title() {
    if (this.state.view === false) {
      return "お知らせ新規登録";
    }
    return "お知らせ更新";
  }

  uploadImageCallback(imageIdList, imageFolderId, selectedId){
    this.setState({
      data:{
        ...this.state.data,
        values:{
          ...this.state.data.values,
          images:imageIdList,
          image_url:imageIdList,
          thumbnail_url:selectedId
        },
      }
    })
  }

  customerSelected(customer) {
    
    // すでに登録済みの場合はアラート表示
    console.log("this.state.targetCustomers ", this.state.targetCustomers)
    console.log("customer ", customer)


    // 顧客単位２の場合は顧客確認
    let checkCustomer;
    let checkCustomerBranch;
    if(this.state.data.values.data_type === 2){
      checkCustomer = this.state.targetCustomers.find(item => item.customer_id === customer.customer_id);

        // 顧客単位３の場合は顧客、支店確認
    } else if(this.state.data.values.data_type === 3){
      checkCustomerBranch = this.state.targetCustomers.find(item => item.customer_id === customer.customer_id && item.customer_branch_id === customer.customer_branch_id);
    }
    if(checkCustomer || checkCustomerBranch){
      this.props.alertModal.current.showErrorModal({messageNo:2501});
      return;
    }
  
    if (customer) {
      this.setState({
        targetCustomers : [...this.state.targetCustomers, customer]
      });
    }
  }

  /*
  *　関数・変数名：
  *     render ：react.Componentで用意されているrender関数
  *              この関数内のタグが表示される
  *     
  */   
  render() {
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3">{this.set_title()}</CardTitle>
                </CardHeader>
                <Col md="11" className="detail">
                  <SystemInfo
                    id_title='お知らせID'
                    id_value={this.state.data.values.information_id}
                    update_timestamp={this.state.data.values.update_date}
                    update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                    update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                    visible={this.state.view} />

                  <CardTitle tag="h4">お知らせ情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="5">仕入先情報</th> */}
                        <CustomTd label="登録単位"
                            name="INFORMATION__data_type"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputSelect
                                options={cst_information_data_type}
                                validateCallback={this.validateCallback}
                                rootData={this.state.data} 
                                isSearchable={true}
                                isNull={true}
                                validateType="regist" 
                              />
                            } />
                      </tr>
                      <tr>
                        {/* <th rowSpan="5">仕入先情報</th> */}
                        <CustomTd label="非ログインユーザー向け表示フラグ"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <>
                              <InputCheckBox 
                                label="非ログイン時にも表示する"
                                labelOn={false}
                                name="INFORMATION__not_login"
                                validateCallback={this.validateCallback} 
                                checkedValue={1}
                                uncheckedValue={0}
                                disabled={this.state.data.values.data_type == 1 ? false: true}
                                rootData={this.state.data}
                              />
                              </>
                            } />
                      </tr>
                      {this.state.data.values.data_type != "1" && this.state.data.values.data_type != "5" &&
                        <tr>
                          <CustomTd label="ターゲット"
                            name="INFORMATION__target_customer"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <>
                                <Button color="secondary small-btn" onClick={() => { 
                                  this.setState({
                                    customerTarget:'customer1'
                                  },()=>{
                                    this.information_customer_select_popup.current.show();
                                  })
                                }}>顧客選択</Button>
                                <div  className="imageComponent" style={{ width: "100%", height: "200px", overflowX: "hidden", overflowY: "scroll" }}>
                                  {this.state.targetCustomers.map((customer, index)=>{
                                    return (
                                      <Row>
                                        <Col>
                                          {`${customer.customer_name ? customer.customer_name : ''}`} 
                                        </Col>
                                        <Col>
                                          {`${customer.customer_branch_name ? customer.customer_branch_name : ''}`} 
                                        </Col>
                                        <Col>
                                          {`${customer.customer_user_name ? customer.customer_user_name : ''}`} 
                                        </Col>
                                        <Col>
                                          <Button
                                            color="secondary small-btn"
                                            onClick={()=>{
                                              const newTargetCustomers = [
                                                ...this.state.targetCustomers.slice(0, index),
                                                ...this.state.targetCustomers.slice(index + 1)
                                              ]
                                              this.setState({
                                                targetCustomers : newTargetCustomers
                                              })
                                            }}
                                          >削除</Button>
                                        </Col>
                                      </Row>
                                    )
                                  })}
                                </div>
                              </>
                          } />
                        </tr>
                      }
                      <tr>
                        <CustomTd label='掲載開始日時'
                            name='INFORMATION__start_date'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputDatetime
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                disabled={false}
                                timeFormat={true}
                              />
                            }
                        />
                      </tr>
                      <tr>
                      <CustomTd label='掲載終了日時'
                            name='INFORMATION__end_date'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputDatetime
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                disabled={false}
                                timeFormat={true}
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label="件名"
                            name="INFORMATION__subject"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback}
                                validateType="regist" />
                              } />
                      </tr>
                      <tr>
                        <CustomTd label="内容"
                          name="INFORMATION__body"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText 
                              validateCallback={this.validateCallback}
                              multiline={true} 
                              validateType="regist" 
                            />
                          } 
                        />
                      </tr>
                      <tr>
                        <td className="subTitle">画像アップロード</td>
                        <td colSpan="3" style={{ position: "relative" }}>
                          <Images
                          {...this.props}
                            ref={this.images}
                            editable={true}
                            name='INFORMATION__image_url'
                            rootData={this.state.data}
                            uploadCallback={this.uploadImageCallback}
                            image_items={this.state.data.values.image_url || []}
                            //imageFolderId={this.state.data.values.image_url}
                            defaultCheckedImage={this.state.data.values.thumbnail_url}
                            selectable={true}
                            gcs_path={'information'}
                            cropData={{
                              unit: 'px',
                              width: 330,
                              aspect: (330 / 165),
                            }}
                           />
                        </td>
                      </tr>
                      <tr>
                        <CustomTd label="外部URL"
                            name="INFORMATION__ad_url"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback}
                                validateType="regist" />
                              } />
                      </tr>
                      <tr>
                       <CustomTd label="表示位置ヘッダー"
                          name="INFORMATION__display_header"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_information_display_header}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label="表示位置広告エリア"
                          name="INFORMATION__display_advertisement"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_information_display_advertisement}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label="状態"
                          name="INFORMATION__status"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_information_status}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                    </tbody>
                  </Table>

                  <Row md="12">
                    <Col md="6" className="text-center">
                      <Button color="secondary" onClick={() => { 
                        if(this.state.view === false){
                          this.props.history.push('/information') 
                        } else {
                          this.props.history.push(`/information/detail/${this.props.match.params.information_id}`) 
                        }
                      }}>キャンセル</Button>
                    </Col>
                    <Col md="6" className="text-center">
                      <ButtonWithRole
                        // button_id={this.state.view?"BTN_M2_04_04350":"BTN_M2_02_04290"}
                        color="info"
                        onClick={() => {
                          if(this.validate()){
                            this.toggleRegistModal()
                          }
                        }}
                      >
                        {this.button_name()}
                      </ButtonWithRole>
                    </Col>
                  </Row>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>

        {/* 登録・更新確認用モーダル */}
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>{this.button_name()}しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole 
              // button_id={this.state.view?"BTN_M2_04_04370":"BTN_M2_02_04310"}
              color="info" 
              onClick={() => { this.toggleRegistModal(); this.regist(); }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        <InformationCustomerSelectPopup 
          buttons={this.props.buttons}
          view={this.state.view}
          ref={this.information_customer_select_popup} 
          customerSelectedCallback={(customer)=>this.customerSelected(customer)}
          dataType={this.state.data.values.data_type}
        />
      </>
    );
  }
}

export default Regist;
